import {visibilityFilter} from 'utils/VisibilityFilter';

const key = 'signinOptions';
const searchInProperties = ['language'];

const defaultOptions = {
    language: 'en',
    show_regurn_to: true,
    max_regurn_to: 2,
    password_and_sso: false,
};

export const signinOptionsSelector = (state) => {
    return state[key].records.ids.map((id) => {
        return state[key].records.byId[id];
    });
};

export const signinOptionSelector = (state, id) => {
    return state[key].records.byId[id];
};

export const defaultSigninOptionSelector = (state) => {
    const collection = signinOptionsSelector(state);
    if (Array.isArray(collection) && collection.length > 0) {
        return signinOptionSelector(state, collection[0].id);
    }
    return defaultOptions;
};

export const signinOptionsCountSelector = (state) => {
    return state[key].records.ids.length;
};

export const visibilityPropsSelector = (state) => {
    const items = signinOptionsSelector(state);

    const page = state[key].visibility.page;
    const limit = state[key].visibility.limit;

    const totalCount = state[key].records.totalCount;

    const keyword = state[key].visibility.keyword;

    const visibleItems = visibilityFilter(
        items,
        page,
        limit,
        searchInProperties,
        keyword
    );

    return {
        items: visibleItems,
        page: page,
        limit: limit,
        totalCount: totalCount,
    };
};
